import React, { useState } from 'react'
import { Badge, Drawer, Dropdown, Menu, Tabs } from "antd"
import pluralize from 'pluralize'
import Select from 'react-select'
import { Route, Switch, Link, useHistory, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

import Receive from '../reusable/receive'

import SingleItemRequest from '../modals/singleItemRequest'
import IssueSingleRequest from '../modals/issueSingleRequest'

const { TabPane } = Tabs

const ItemRequests = ({ path, onPerform  }) => {
    const [destination, setDestination] = useState()
    const [string, setString] = useState('')
    const [sString, setSString] = useState('')
    const [type, setType] = useState('')
    const [rqType, setRqType] = useState('')
    const [classif, setClass] = useState({ label: 'All', value: 'All' })
    const [key, setKey] = useState("0")
    const [stores, setStores] = useState([])
    const [store, setStore] = useState()
    const [itms, setItems] = useState([])
    const [count, setCount] = useState([])

    const [visible, toggle] = useToggle(true)

    const history = useHistory()

    const { id } = useParams()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    const [, getRequests] = usePet('requestsByStore', { store: id, type: "Received", classif: 'Pending' }, { notify: true, callback: ({ data }) => setCount(data.count) })

    const [
        { loading: rqLoading, error: rqError, fetch },
        { list: requests },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('requestsByStore', {
        store: id,
        type,
        classif: classif?.value,
        string: sString
    }, { notify: true }, 'requests')

    const [
        { loading: drLoading, error: drError, fetch: fetchDR },
        { list: departmentRequests },
        { navigate: dNavigate, Paginate: DPaginate, page: dPage = 1, limit: dLimit = 10 }
    ] = useListData('departmentRequests', {
        store: id,
        type,
        classif: classif?.value,
        string: sString
    }, { notify: true }, 'requests')
    
    const [
        { loading: prLoading, error: prError, fetch: fetchPR },
        { list: patientRequests },
        { navigate: pRNavigate, Paginate: PPaginate, page: pPage = 1, limit: pLimit = 10 }
    ] = useListData('patientRequests', {
        store: id,
        type,
        requestType: rqType,
        classif: classif?.value,
        string: sString
    }, { notify: true }, 'requests')

    usePet('stores', { limit: 50, active: true, order: 1 }, { notify: true, callback: ({ data }) => {
        setStores(data.stores)
        let itm = data.stores.find(sto => sto === id)
        setStore(itm)
     } })

    const rRefresh = (str = "", resetNav) => {
        if (resetNav)
            navigate(1)

        setSString(str)
        fetch()
    }

    const dRefresh = (str = "", resetNav) => {
        if (resetNav)
            dNavigate(1)

        setSString(str)
        fetchDR()
    }

    const pRefresh = (str = "", resetNav) => {
        if (resetNav)
            pRNavigate(1)

        setSString(str)
        fetchPR()
    }

    const refresh = () => {
        rRefresh()
        dRefresh()
        pRefresh()
    }

    const changeClassif = val => {
        setClass(val)
        refresh()
    }

    const onKeyChange = k => {
        setKey(k)
        if (k === "1") {
            setType("Sent")
        } else if (k === "2") {
            setSString("")
            setType("Received")
        } else if (k === "3") {
            setSString("")
            setType("Received")
        } else if (k === "4") {
            setSString("")
            setType("Received")
            setRqType("Inpatient")
        } else if (k === "5") {
            setSString("")
            setType("Received")
            setRqType("Consumables")
        }

        setTimeout(refresh, 100)
    }

    const onComplete = ({ }, notif, ops) => {
        // onPerform()
        notif('Request has been sent', ops('success'))
        setItems([])
        onKeyChange("1")
    }

    const [{ loading }, execute] = usePet('requestItems', {
        source: id,
        destination: destination?._id,
        requests: itms
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Sending request...' } })

    const changeQty = (val, key) => {
        let temp = [...itms]
        temp[key].quantity = val

        setItems(temp)
    }

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const searchSent = str => {
        setSString(str)
        if (str?.trim()?.length > 2 || !str)
            refresh(str)
    }

    const close = () => {
        toggle()
        setTimeout(() => history.push(path), 300)
    }

    const onClose = () => {
        fetch()
        fetchDR()
        fetchPR()
        getRequests()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    {
                        key === "0" ?
                        <button disabled={loading} onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Send Request</button>
                        : null
                    }
                </div>
            }
            width={1000}>
            <p className="font-extrabold text-3xl mb-0">Item Requests</p>
            <Tabs activeKey={ key } onChange={ onKeyChange } className="min-h-fullf">
                <TabPane key="0" tab="New Request">
                    <div className="flex flex-wrap -mx-3 mb-2">
                        <div className="w-full md:w-1/2 px-3 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Destination
                            </label>
                            <Select
                                isLoading={invLoading}
                                loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                value={destination}
                                onChange={setDestination}
                                options={stores ? stores.filter(sto => sto._id !== id).map(sto => ({ label: sto.name, value: sto._id, ...sto })) : [] }
                                placeholder="Select Destination" />
                        </div>
                    </div>
                    <div className="w-full mb-3">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                            Items
                        </label>
                        <Select
                            isMulti
                            isLoading={invLoading}
                            loadingMessage={str => `Searching for "${str?.inputValue}"`}
                            onInputChange={search}
                            value={itms}
                            onChange={setItems}
                            options={items.map(itm => ({ label: itm.name, value: itm._id, item: itm._id, quantity: 0, ...itm }))}
                            placeholder="Search for inventory item" />
                    </div>
                    {
                        itms.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2 pl-4 text-center">
                                            <div className="font-semibold">No.</div>
                                        </th>
                                        <th className="p-2 pl-4 text-left">
                                            <div className="font-semibold">Item</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Quantity</div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        itms.map((item, key) =>
                                            <tr>
                                                <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                                <td className="p-2 pl-4 h-5">{item?.name}</td>
                                                <td className="p-2 pl-4 h-5 text-center">
                                                    <div className="flex justify-center">
                                                        <input
                                                            className="appearance-none block text-center max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                                            id="grid-qty-item"
                                                            value={ item.quantity }
                                                            onChange={ e => changeQty(e.target.value, key) }
                                                            placeholder={ `How many ${item.receivedIn.toLowerCase()}?` }
                                                            type="number"/>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            : <div className="flex items-center justify-center h-28">
                                <h2>You can add items by clicking above</h2>
                            </div>

                    }
                </TabPane>
                <TabPane key="1" tab="Sent Requests">
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={rqError}
                            loading={rqLoading}
                            progress>
                            {
                                requests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent To</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                requests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{request.requestedBy?.name}</div>
                                                            <p className="text-gray-500 text-xs italic">{request.requests.length} {pluralize('items', request.requests.length)}</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{request.destination.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `${path}/requests/${id}/${request._id}` }>
                                                                <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req.discarded) ? 'Discarded' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </TabPane>
                <TabPane key="2" tab={ 
                    <Badge count={ count }>
                        <span>Store Requests</span>
                    </Badge>
                }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={rqError}
                            loading={rqLoading}
                            progress>
                            {
                                requests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent From</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                requests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{request.requestedBy.name}</div>
                                                            <p className="text-gray-500 text-xs italic">{request?.requests?.length} {pluralize('items', request?.requests?.length)}</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{request?.source?.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req?.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `${path}/requests/${id}/${request._id}${request.issued ? '' : '/issue'}` }>
                                                                <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req?.discarded) ? 'Discarded' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent to { store?.name }</h2>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </TabPane>
                <TabPane key="3" tab={ 
                    <Badge count={ count }>
                        <span>Department Requests</span>
                    </Badge>
                }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={drError}
                            loading={drLoading}
                            progress>
                            {
                                departmentRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Department</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                departmentRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((dPage - 1) * dLimit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request.requestedBy.name }</div>
                                                            <p className="text-gray-500 text-xs italic">{ request.requests.length } { pluralize('items', request.requests.length) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.department }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `${path}/requests/${id}/${request._id}${request.issued ? '' : '/issue'}` }>
                                                                <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req.discarded) ? 'Discarded' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {DPaginate}
                    </div>
                </TabPane>
                <TabPane key="4" tab={ 
                    <Badge count={ count }>
                        <span>Inpatient Requests</span>
                    </Badge>
                }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={prError}
                            loading={prLoading}
                            progress>
                            {
                                patientRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patientRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((pPage - 1) * pLimit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request?.patient?.name } ({ request?.requestType === 'Consumables' ? request?.patient?.opNo : request?.patient?.ipNo ?? request?.patient?.tempIpNo })</div>
                                                            <p className="text-gray-500 text-xs italic">{ request?.requests?.length } { pluralize('items', request.requests.length) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.requestedBy.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `${path}/requests/${id}/${request._id}${request.issued ? '' : '/issue'}` }>
                                                                <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req.discarded) ? 'Discarded' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {PPaginate}
                    </div>
                </TabPane>
                <TabPane key="5" tab={ 
                    <Badge count={ count }>
                        <span>Procedure Consumables</span>
                    </Badge>
                }>
                    <div className="overflow-x-auto">
                        <span className="flex justify-between items-center">
                            <input
                                onChange={e => searchSent(e.target.value)}
                                value={ sString }
                                className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ssearch"
                                type="text"
                                placeholder="Evans Kimani" />
                            <Select
                                value={classif}
                                onChange={ changeClassif}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ ['All', 'Pending', 'Seen'].map(cls => ({ label: cls, value: cls })) }
                                placeholder="Viewed Status" />
                        </span>
                        <Receive
                            error={prError}
                            loading={prLoading}
                            progress>
                            {
                                patientRequests.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patientRequests.map((request, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((pPage - 1) * pLimit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ request?.patient?.name } ({ request?.requestType === 'Consumables' ? request?.patient?.opNo : request?.patient?.ipNo ?? request?.patient?.tempIpNo })</div>
                                                            <p className="text-gray-500 text-xs italic">{ request?.requests?.length } { pluralize('items', request.requests.length) }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ request?.requests?.every(req => req?.issued) ? 'text-green-500' : request?.requests?.every(req => req.discarded) ? 'text-gray-500' : request.seen ? 'text-blue-600' : 'text-yellow-500' }>{request?.requests?.every(req => req?.issued) ? 'Issued' : request.seen ? 'Seen' : 'Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ request.requestedBy.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(request.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={ `${path}/requests/${id}/${request._id}${request.issued ? '' : '/issue'}` }>
                                                                <button className={ `text-white ${ request?.requests?.every(req => req?.issued) ? 'hisani-btn-green-light' : request?.requests?.every(req => req.discarded) ? 'Discarded' : request.seen ? 'bg-blue-600' : 'hisani-btn-orange-light' } font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center` }>View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No requests { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } have been sent yet</h2>
                                    </div>
                            }
                        </Receive>
                        {PPaginate}
                    </div>
                </TabPane>
            </Tabs>
            <Switch>
                <Route exact path={ `${path}/requests/:id/:rq` }>
                    <SingleItemRequest path={ path } onPerform={ () => null } />
                </Route>
                <Route path={ `${path}/requests/:id/:rq/issue` }>
                    <IssueSingleRequest path={ path } onPerform={ onClose } />
                </Route>
            </Switch>
        </Drawer>
    )
}

export default ItemRequests